import '../tables/Table.module.css'
function FactorTableEditorCycle(props) {

    const colNames =  ['Factor Name', 'Type', 'Range', 'Unit', 'Remarks'];   
    let tableHead = (
        <>
            <tr style={{fontSize: '14px'}}>
                {colNames.map((columnName, index) => (<th key={index} >{columnName}</th>))}
            </tr>
        </>);

    let tableRows = (<></>);

    tableRows = props.factors.map((factor, id) => (
        <tr key={`row_${id}`}>
            <td key={`name_${id}`}>
                <div style={{ fontSize: '14px' }}>
                    {factor.name}
                </div>
            </td>
            <td key={`type_${id}`}>
                <div style={{ fontSize: '14px' }}>
                    {factor.type}
                </div>
            </td>
            <td key={`range_${id}`}>
                <div style={{ display:'flex', fontSize: '14px' }}>
                <input 
                    id={`range_min_${id}`}
                    type='number' 
                    placeholder='min' 
                    autoComplete='false' 
                    value={factor.range_min !== null ? factor.range_min : ''} 
                    onChange={props.inputHandler}
                    style={{fontSize: '14px', border:'0.5px solid var(--aixelo-gray)', width:'60px'}}/>
                    <p style={{margin:'0px', padding:'0px', paddingLeft:'5px', paddingRight:'5px', fontSize: '14px'}}>-</p>
                <input 
                    id={`range_max_${id}`}
                    type='number' 
                    placeholder='max' 
                    autoComplete='false' 
                    value={factor.range_max !== null ? factor.range_max : ''} 
                    onChange={props.inputHandler}
                    style={{fontSize: '14px', border:'0.5px solid var(--aixelo-gray)', width:'60px'}}/>
                </div>
            </td>
            <td key={`units_${id}`}>
                <div style={{fontSize: '14px', minWidth:'90px'}}>
                   
                    {factor.units}
                    
                    </div>
            </td>
            <td key={`remarks_${id}`}>
                <input 
                    id={`remarks_${id}`} 
                    type='text' 
                    placeholder='Enter remarks ...' 
                    autoComplete='false' 
                    value={factor.remarks} 
                    onChange={props.inputHandler}
                    style={{fontSize: '14px', minWidth:'200px'}}
                    />
            </td>
        </tr>
    ));





    return(<>
        <table style={{ tableLayout: 'auto' }}>
            <thead >
                {tableHead}
            </thead>
            <tr><div style={{height: '4px'}} colSpan={colNames.length}></div></tr>
            <tbody style={{border: '0.5px solid var(--aixelo-gray-light)'}}>
                {tableRows}
            </tbody>
        </table>
    </>
    );

}


export default FactorTableEditorCycle;
